/**
 * 埋点存储
*/
import { defineStore } from 'pinia'
import { ref } from 'vue'
export const useBurialPointStore = defineStore('burialPoint', () => {

    // 是否编辑聊天记录
    const isEdit = ref(false)
    // 输入框文字字数
    const inputTextLength = ref(0)
    // 文风功能选择
    const isStyle = ref(false)
    // 视角功能选择
    const isPerspective = ref(false)
    const setIsPerspective = (value: boolean) => {
        isPerspective.value = value
    }

    const getIsPerspective = () => {
        return isPerspective.value
    }

    const removeIsPerspective = () => {
        isPerspective.value = false
    }

    const setIsStyle = (value: boolean) => {
        isStyle.value = value
    }

    const getIsStyle = () => {
        return isStyle.value
    }

    const removeIsStyle = () => {
        isStyle.value = false
    }

    const setInputTextLength = (value: number) => {
        inputTextLength.value = value
    }

    const getInputTextLength = () => {
        return inputTextLength.value
    }

    const removeInputTextLength = () => {
        inputTextLength.value = 0
    }

    const setIsEdit = (value: boolean) => {
        isEdit.value = value
    }

    const getIsEdit = () => {
        return isEdit.value
    }

    const removeIsEdit = () => {
        isEdit.value = false
    }

    return {
        isPerspective,
        setIsPerspective,
        getIsPerspective,
        removeIsPerspective,
        isStyle,
        setIsStyle,
        getIsStyle,
        removeIsStyle,
        isEdit,
        setIsEdit,
        getIsEdit,
        removeIsEdit,
        inputTextLength,
        setInputTextLength,
        getInputTextLength,
        removeInputTextLength
    }
})
